var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.25 1.25v17.5h11v2.5H8v1.5h8v-1.5h-3.25v-2.5h11V1.25H.25zm1.37 13.5h20.75v-1.5H1.62v1.5z",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25 1.25v17.5h11v2.5H8v1.5h8v-1.5h-3.25v-2.5h11V1.25H.25zm1.37 13.5h20.75v-1.5H1.62v1.5z",
    fill: "#6e6e6e",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e90a0a",
    d: "M0 0h6.27v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26221e",
    d: "M6.27 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8600",
    d: "M6.98 0h6.46v24H6.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ae0000",
    d: "M13.44 0h4.22v24h-4.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065b1",
    d: "M17.66 0h1v24h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008520",
    d: "M18.11 0H24v24h-5.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.846f09249b23cd43565eefcf77650a70.svg";
export { ForwardRef as ReactComponent };